<template>
  <section class="ad-2026">
    <div class="image-area">
      <img :src="adImage" class="ad-image" alt="2026 광고 이미지" />
    </div>
    <div class="button-area">
      <div class="logo">
        <img :src="require('@/assets/2026/images/logo_black.png')" alt="짐빔 로고" />
      </div>
      <div class="pickup">
        <img :src="require('@/assets/2026/images/pickup.png')" alt="짐빔 하이볼 할인전 픽업하기" />
      </div>
      <div class="button-bar">
        <button id="gs25" @click.prevent="handleClick('gs25')">
          <img :src="require('@/assets/2026/images/02_btn_01.png')" alt="GS25에서 구매하기" />
        </button>
        <button id="cu" @click.prevent="handleClick('cu')">
          <img :src="require('@/assets/2026/images/02_btn_02.png')" alt="CU에서 구매하기" />
        </button>
        <!-- <button id="dailyshot" @click.prevent="handleClick('dailyshot')">
          <img :src="require('@/assets/2025/images/02_btn_04.png')" alt="데일리샷에서 구매하기" />
        </button> -->
      </div>
      <div class="warning">경고: 지나친 음주는 뇌졸중, 기억력 손상이나 치매를 유발합니다. <br />임신 중 음주는 기형아 출생 위험률을 높입니다.</div>
    </div>
  </section>
</template>

<script setup>
const adImage = process.env.BASE_URL + 'img/01_bg_resize_2026.png'

const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

const LINKS = {
  gs25: 'https://abr.ge/e3c1pkb',
  cu: 'https://www.pocketcu.co.kr/deepLink/checkAppInstall?viewType=1&viewUrl=/search/stock?isRecommend=Y&item_cd=5010278107016'
  // dailyshot: 'https://webview.dailyshot.co/event?service_type=0&event_id=645'
}

const handleClick = target => {
  if (isMobile()) {
    window.open(LINKS[target], 'outer')
  } else {
    alert('모바일에서만 사용이 가능합니다.')
  }
}
</script>

<style scoped>
.ad-2026 {
  display: flex;
  flex-direction: column;
  width: var(--contents-width);
  max-width: var(--max-contents-width);
  height: 100vh;
  height: 100svh;
  margin: 0 auto;
}

.image-area {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  line-height: 0;
}

.ad-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  display: block;
}

.button-area {
  flex: 0 0 auto;
  min-height: 18vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 1rem 1.5rem 1rem;
  background: #fffaed;
  color: #040404;
  text-align: center;
}

.button-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}

.button-bar button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}

.button-bar button img {
  height: 3.5rem;
  width: auto;
  display: block;
}
.warning {
  font-size: 0.65rem;
  color: #cac6bc;
  word-break: keep-all;
  margin: 0.2rem auto;
}
.logo img {
  max-width: 100%;
  width: 4rem;
  margin: 0 auto 0.3rem auto;
}
.pickup img {
  max-width: 100%;
  height: 2rem;
}
@media (min-width: 640px) {
  .ad-2026 {
    width: auto;
    max-width: var(--desktop-contents-width);
    min-height: var(--desktop-contents-height);
  }
}
</style>
